import { LOG_OUT } from "../login/action";
import {  SET_VEHICLE_REQUIRED_FIELD } from "./action";

export const defaultState = {
  vehicleRequiredFields: [],
};

function VehicleRequiredFields(state = defaultState, action) {
  switch (action.type) {
    case SET_VEHICLE_REQUIRED_FIELD:
      return {
        ...state,
        vehicleRequiredFields: action.payload,
      };
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default VehicleRequiredFields;
